import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Pill.module.css';

const Pill = ({ color, text }) => (
  <span styleName={classNames('pill', color)}>{text}</span>
);

Pill.propTypes = {
  color: PropTypes.oneOf(['blue', 'light-blue', 'light-grey', 'black', 'red']),
  text: PropTypes.string
};

export default Pill;
